import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  AutonomousCommunity,
  BuyerType,
  ContactType,
  GreatRegistryResponse,
  InterestProp,
  InvestCarouselResponse,
  PayloadGreatRegistry,
} from '@app/@shared/model/invest.model';
import { SERVER_API_URL } from '@app/app.constants';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InvestService {
  constructor(private http: HttpClient) {}

  getCarousel(): Observable<InvestCarouselResponse[]> {
    return this.http.get<InvestCarouselResponse[]>(`${SERVER_API_URL}carousel`);
  }

  getBuyerType(): Observable<BuyerType[]> {
    return this.http.get<BuyerType[]>(`${SERVER_API_URL}buyer-type`);
  }

  getAutonomousCommunity(): Observable<AutonomousCommunity[]> {
    return this.http.get<AutonomousCommunity[]>(
      `${SERVER_API_URL}autonomous-community`
    );
  }

  getContactType(): Observable<ContactType[]> {
    return this.http.get<ContactType[]>(`${SERVER_API_URL}contact-type`);
  }

  getInterestProp(): Observable<InterestProp[]> {
    return this.http.get<InterestProp[]>(`${SERVER_API_URL}interest-prop`);
  }

  postGreatInvestorRegistry(
    data: PayloadGreatRegistry
  ): Observable<GreatRegistryResponse> {
    return this.http.post<GreatRegistryResponse>(
      `${SERVER_API_URL}great-investor-registry`,
      data
    );
  }

  getGreatInvestorRegistry(
    id: number | string
  ): Observable<GreatRegistryResponse> {
    return this.http.get<GreatRegistryResponse>(
      `${SERVER_API_URL}great-investor-registry/${id}`
    );
  }
}
